// DelegationBar.tsx
import { Button } from '@/components/shared/button/Button';
import { useAuthenticationService } from '@/services/authentication/authentication-service';
import React from 'react';
import { MdExitToApp } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import strings from './tenantManagement.translations';

export const DelegationBar: React.FC = () => {
  const navigate = useNavigate();
  const { user, setDelegation } = useAuthenticationService(state => ({
    user: state.user,
    setDelegation: state.setDelegation
  }));

  // Return null if not currently delegating
  if (!user?.delegation?.isDelegating) return null;

  // Handler to exit delegation
  const exitDelegation = () => {
    setDelegation({ isDelegating: false, delegatedTenantId: undefined, delegatedTenantName: undefined });
    navigate('/', { replace: true });
  };

  return (
    <div className="bg-secondary-500 text-white px-4 py-2 flex justify-between items-center">
      {/* Display delegated tenant and role */}
      <span>
        {strings.delegationBar.actingAs(user.delegation.delegatedTenantName ?? strings.delegationBar.unknownTenant)}
      </span>

      {/* Exit delegation button */}
      <Button onClick={exitDelegation} className="flex items-center gap-1">
        <MdExitToApp size={16} />
        {strings.delegationBar.exit}
      </Button>
    </div>
  );
};
